import React from 'react'
import { Container, Flex, Text } from 'theme-ui'

import Section from './../Section/index'
import { useResponsiveValue } from '@theme-ui/match-media'
import Button from './../../atoms/Button'
import PaymentList from './../../organisms/PaymentList'
import Image from './../../atoms/Image'
import { DepositAndWithdrawProps } from './types'

const DepositAndWithdrawSection: React.FC<DepositAndWithdrawProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data
}) => {
  const isTablet = useResponsiveValue([false, true, true, true], {
    defaultIndex: 0
  })
  return (
    <Section
      {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, subheading, description, data }}
      body={
        <Container variant="depositAndWithdrawSection.container">
          {data.title || data.description || data.image ? (
            <Flex variant="depositAndWithdrawSection.content">
              {isTablet && data.image ? (
                <Flex variant="depositAndWithdrawSection.image">
                  <Image objectFit="contain" fluid={data.image.childImageSharp} alt={data.image.alt} />
                </Flex>
              ) : (
                ''
              )}
              <Flex variant="depositAndWithdrawSection.text">
                {data.title && (
                  <Text
                    as="h2"
                    sx={{
                      variant: 'headingRaleway2',
                      fontFamily: 'secondary',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      marginBottom: ['24px', '18px'],
                      maxWidth: ['218px', '100%', '']
                    }}
                  >
                    {data.title}
                  </Text>
                )}
                {data.description && (
                  <Text
                    as="p"
                    sx={{
                      variant: 'headingMontserrat3',
                      textAlign: 'center',
                      marginBottom: ['22px', '44px']
                    }}
                  >
                    {data.description}
                  </Text>
                )}
                {isTablet && !!data.button && <Button variant="withArrow" {...data.button} />}
              </Flex>
            </Flex>
          ) : (
            ''
          )}
          {data.list && (
            <Flex variant="depositAndWithdrawSection.list">
              <PaymentList data={data.list} />
            </Flex>
          )}
          {!isTablet && data.button ? (
            <Flex
              sx={{
                justifyContent: 'center'
              }}
            >
              <Button variant="withArrow" url={data.button.url} urlText={data.button.urlText} />
            </Flex>
          ) : (
            ''
          )}
        </Container>
      }
    />
  )
}

export default DepositAndWithdrawSection
